<div class="row">
    <div [ngClass]="carrierContractID >= 0 ? 'col-sm-3' : 'col-sm-12'">
        <kendo-grid #carrierContractGrid
                    [data]="gridData"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    [autoSize]="false"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" width="75">
                <ng-template kendoGridCellTemplate let-load>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(load)"><i class="fas fa-pencil-alt"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="parentQuoteOrderID" title="Parent Order #">
                <ng-template kendoGridCellTemplate let-load>
                    <a target="_blank" [routerLink]="['/order-entry', load.parentQuoteOrderID]">{{load.parentOrderNumber}}-{{ load.legNumber}}</a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="quoteOrderID" title="Order #">
                <ng-template kendoGridCellTemplate let-load>
                    <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="legNumber" title="Load #"></kendo-grid-column>-->
            <kendo-grid-column field="masterOrderDescription" title="Master Order Desc"></kendo-grid-column>
            <kendo-grid-column field="expirationDate" title="Expiration">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.isExpired != true">{{load.expirationDate == '' ? '' : load.expirationDate | date: 'M/dd/yy'}}</span>
                    <span *ngIf="load.isExpired == true" class="text-danger fw-bold">EXPIRED</span>
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="isExpired" title="Expired" class="text-center">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isExpired != true && (load.expirationDate == null || load.expirationDate > utcNow)" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isExpired == true || load.expirationDate != null && load.expirationDate <= utcNow" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>-->
            <kendo-grid-column field="originCityStateZip" title="Origin"></kendo-grid-column>
            <kendo-grid-column field="destinationCityStateZip" title="Destination"></kendo-grid-column>
            <!--<kendo-grid-column field="isMacropointRequired" title="MP Required" class="text-center">
                <ng-template kendoGridCellTemplate let-load>
                    <i *ngIf="load.isMacropointRequired!=true" class="far fa-square fa-lg text-secondary"></i>
                    <i *ngIf="load.isMacropointRequired==true" class="fas fa-check-square fa-lg text-primary"></i>
                </ng-template>
            </kendo-grid-column>-->
            <kendo-grid-column field="opportunityName" title="Opportunity"></kendo-grid-column>
            <kendo-grid-column field="carrierCode" title="Carrier">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.carrierID > 0">
                        <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                            {{load.carrierName}}
                        </a>
                        <br />
                        <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                            {{load.carrierCode}}
                        </a>
                    </span>
                    <span *ngIf="load.carrierID == null">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="awardedCarrierRepName" title="Carrier Rep">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.awardedCarrierRepID > 0">
                        {{load.awardedCarrierRepName}}
                    </span>
                    <span *ngIf="load.awardedCarrierRepID == null">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="carrierContactName" title="Contact">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.carrierContactID > 0">
                        {{load.carrierContactName}}
                    </span>
                    <span *ngIf="load.carrierContactID == null">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="driverName" title="Driver">
                <ng-template kendoGridCellTemplate let-load>
                    <!--<div *ngIf="load.isMacropointRequired && load.macropointTrackType == 'Mobile' && load.driverID == null">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </div>-->
                    <div *ngIf="load.driverID > 0">
                        <div>
                            {{load.driverName}}
                        </div>
                        <div *ngIf="load.driverCell != ''">
                            c: {{load.driverCell}}
                        </div>
                        <!--<div *ngIf="load.isMacropointRequired && load.macropointTrackType == 'Mobile' && load.driverCell == ''">
                            c: <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                        </div>-->
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="driver2Name" title="Driver 2">
                <ng-template kendoGridCellTemplate let-load>
                    <div>
                        {{load.driver2Name}}
                    </div>
                    <div *ngIf="load.driver2Cell != ''">
                        c: {{load.driver2Cell}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="truckNumber" title="Truck #">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.truckNumber != ''">
                        {{load.truckNumber}}
                    </span>
                    <!--<span *ngIf="load.isMacropointRequired && load.macropointTrackType == 'VehicleID' && load.truckNumber == ''">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </span>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="trailerNumber" title="Trailer #">
                <ng-template kendoGridCellTemplate let-load>
                    <span *ngIf="load.trailerNumber != ''">
                        {{load.trailerNumber}}
                    </span>
                    <!--<span *ngIf="load.isMacropointRequired && load.macropointTrackType == 'TrailerID' && load.trailerNumber == ''">
                        <span class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                    </span>-->
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="mcNumber" title="MC #"></kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City"></kendo-grid-column>
    <kendo-grid-column field="originState" title="O-St"></kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City"></kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-St"></kendo-grid-column>-->
            <kendo-grid-column field="offerRatePerMile" title="Rate/mi" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="offerRate" title="Rate" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="startDate" title="Start">
                <ng-template kendoGridCellTemplate let-load>
                    {{load.startDate == '' ? '' : load.startDate | date: 'M/dd/yy'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-9" *ngIf="carrierContractID >= 0">
        <div class="k-float-right">
            <button type="button" class="btn btn-secondary" (click)="carrierContractID = -1"><i class="fas fa-times"></i></button>
        </div>
        <carrier-contract-form [carrierContractID]="carrierContractID" [masterQuoteOrderLineID]="masterQuoteOrderLineID" [quoteOrderLineID]="quoteOrderLineID" (onRefresh)="refreshContracts()"></carrier-contract-form>
    </div>
</div>
